import { Component, Inject, OnInit } from '@angular/core';

import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Paginacao } from "@app/models/util/paginacao";

import { FormaDePagamento } from '@app/models/forma-de-pagamento.model';
import { FormaDePagamentoService } from '@app/services/forma-de-pagamento.service';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-forma-de-pagamento-lista',
  templateUrl: './forma-de-pagamento-lista.component.html'
})

export class FormaDePagamentoListaComponent implements OnInit {

  lstFormaDePagamento: FormaDePagamento[];
  paginacao: Paginacao = new Paginacao();
  filtroDescricao: string = "";
  bsModalRef: BsModalRef;

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private formaDePagamentoService: FormaDePagamentoService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }

  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.formaDePagamentoService.obteLista(descricao, pagina)
      .toPromise().then(data => {
        this.lstFormaDePagamento = data.Dados,
          this.paginacao.totalDeItens = data.Total
      }, erro => {
        this.toastr.warning("Realize a pesquisa novamente.")
      });
  }

  deletar(formaDePagamento: FormaDePagamento) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = "Deseja realmente deletar a forma de pagamento: " + formaDePagamento.Descricao + "?";
    this.bsModalRef.content.confirmar = () => {
      formaDePagamento
      this.formaDePagamentoService.deletar(formaDePagamento.Id).toPromise().then(() => {
        this.obterTodos(this.filtroDescricao, 1);
        this.paginacao.paginaAtual = 1;
      });
    }
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }

  obterTipoFormaPagamento(tipo: string) {
    switch (tipo) {
      case 'C':
        return 'Crédito';
      case 'D':
        return 'Débito';
      case 'A':
        return 'Crédito/Débito';
      default:
        return '';
    }
  }

}
